<template>
  <div class="faq">
    <!-- Native <details>: every answer is in the HTML (works with no JS and for
         crawlers); the browser handles collapsing. The shared name keeps one
         open at a time in browsers that support exclusive accordions. -->
    <details
      v-for="(item, index) in items"
      :key="index"
      class="row faq-item"
      name="faq"
      :open="index === 0"
    >
      <summary class="trigger faq-q">
        <h3 class="q">{{ item.q }}</h3>
        <span class="sign" aria-hidden="true"></span>
      </summary>
      <p class="a faq-a">{{ item.a }}</p>
    </details>
  </div>
</template>

<script setup>
defineProps({
  items: { type: Array, required: true }
})
</script>

<style scoped>
.faq {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.row {
  background: var(--surface);
  border-radius: var(--radius-inner);
  padding: 22px 26px;
}

.q {
  margin: 0;
  font-size: 19px;
  font-weight: 500;
}

.trigger {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  cursor: pointer;
}

.trigger::-webkit-details-marker {
  display: none;
}

.trigger:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 6px;
  border-radius: 8px;
}

.sign {
  font-size: 24px;
  font-weight: 400;
  flex-shrink: 0;
}

.sign::before {
  content: '+';
}

.row[open] .sign::before {
  content: '–';
}

.a {
  margin-top: 12px;
  font-size: 17px;
  line-height: 1.6;
  color: var(--muted);
}
</style>
